export type PhxSize = 'extra-extra-small' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'extra-extra-large';

export type PhxBackground = 'standard' | 'medium' | 'bold' | 'summary' | 'overlay' | 'inverted' | 'dark';

export type PhxSpacing =
  | 'none'
  | 'extra-extra-small'
  | 'extra-small'
  | 'small'
  | 'small-medium'
  | 'medium'
  | 'medium-large'
  | 'large'
  | 'extra-large'
  | 'extra-extra-large';

export enum PhxComponents {
  Select = 'phx-select',
}
